import React from 'react';
import styled from 'styled-components';

const StyledLabel = styled.label<Partial<Props>>`
  display: inline-flex;
  position: relative;
  align-items: center;
  em {
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.67;
    letter-spacing: normal;
    text-align: left;
    color: #222;
    margin-left: 0.5rem;
  }
  span {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: 1px solid #d3d3d3;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: relative;
    &:after {
      content: '';
      background: #000000;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      opacity: 0;
      transform: scale(0);
      transform-origin: center center;
      display: inline-flex;
      transition: all 0.15s ease;
    }
  }
  input {
    display: none;
    &:checked + span {
      border: 1px solid #000;
      &:after {
        transform: scale(1);
        opacity: 1;
      }
    }
  }
`;

interface Props {
  label?: string;
  testId?: string;
  checked?: boolean;
}

export const CustomRadioButton: React.FC<React.HTMLProps<HTMLInputElement> & Props> = ({
  label,
  testId = '',
  ...rest
}) => {
  return (
    <StyledLabel data-testid={testId}>
      <input type="radio" {...rest} />
      <span />
      {label && <em>{label}</em>}
    </StyledLabel>
  );
};
